import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./RefundRequests.module.sass";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";

const getIconAndColorByType = (type) => {
  switch (type) {
    case 'Incident':
      return { icon: 'alert-circle', fill: '#FF6A55', color: '#FFE7E4' };
    case 'Maintenance':
      return { icon: 'settings', fill: '#FFA726', color: '#FFF3E0' };
    case 'Information':
      return { icon: 'info', fill: '#42A5F5', color: '#E3F2FD' };
    case 'Promotion':
      return { icon: 'gift', fill: '#66BB6A', color: '#E8F5E8' };
    case 'Alerte':
      return { icon: 'alert-triangle', fill: '#FF7043', color: '#FFE0DB' };
    default:
      return { icon: 'info', fill: '#42A5F5', color: '#E3F2FD' };
  }
};

const RefundRequests = ({ className, title, classTitle, banners = [], loading = false }) => {

  return (
    <Card
      className={cn(styles.card, className)}
      title={title}
      classTitle="title-red"
    >
      <div className={styles.section}>
        {loading ? (
          <div className={styles.loading}>Chargement des notifications...</div>
        ) : (
          <>
            <div className={styles.list}>
              {banners.map((banner, index) => {
                const { icon, fill, color } = getIconAndColorByType(banner.type);
                return (
                  <div className={styles.item} key={banner.id || index}>
                    <div className={styles.icon} style={{ backgroundColor: color }}>
                      <Icon name={icon} size="24" fill={fill} />
                    </div>
                    <div className={styles.content}>
                      <strong>{banner.title}</strong><br />
                    </div>
                  </div>
                );
              })}
            </div>
            {banners.some(banner => banner.link) && (
              <a
                className={cn("button-stroke", styles.button)}
                href={banners.find(banner => banner.link)?.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                En savoir plus
              </a>
            )}
          </>
        )}
      </div>
    </Card>
  );
};

export default RefundRequests;
